import type { DocCategory } from '../types/constants';
import { useJsonResource } from './use-json-resource';

export function useConstants(urlVersion: string | undefined) {
  const { loading, error, data } = useJsonResource<DocCategory[]>(urlVersion, 'constants.json');
  return { loading, error, constants: data };
}
